package fr.frux.core.designsystem.components

import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.ModalBottomSheet
import androidx.compose.material3.rememberModalBottomSheetState
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.semantics.Role
import androidx.compose.ui.semantics.contentDescription
import androidx.compose.ui.semantics.onClick
import androidx.compose.ui.semantics.role
import androidx.compose.ui.semantics.semantics
import fr.frux.core.designsystem.resources.Res
import fr.frux.core.designsystem.resources.ds_sheet_close
import org.jetbrains.compose.resources.stringResource

/**
 * `ModalBottomSheet` maison : poignée décorative sans ripple ([FruxDragHandle], le `dragHandle`
 * par défaut de M3 1.9 est enveloppé d'un clickable avec effet) et fermeture par le geste de
 * retour sur toutes les plateformes — Android la tient de la fenêtre de dialogue M3, le web du
 * back navigateur via [InterceptNavigationBack].
 */
@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun FruxModalBottomSheet(
    onDismiss: () -> Unit,
    skipPartiallyExpanded: Boolean = false,
    content: @Composable ColumnScope.() -> Unit,
) {
    InterceptNavigationBack(onBack = onDismiss)
    ModalBottomSheet(
        onDismissRequest = onDismiss,
        sheetState = rememberModalBottomSheetState(skipPartiallyExpanded = skipPartiallyExpanded),
        dragHandle = null,
    ) {
        // Action sémantique seule, sans `clickable` : pas de ripple (le contournement M3 1.9
        // reste entier), mais les lecteurs d'écran et l'automatisation par a11y gagnent une
        // cible de fermeture fiable (#300) — le seul autre nœud exposé est le scrim plein
        // écran, dont le centre retombe sur le contenu de la feuille.
        val closeLabel = stringResource(Res.string.ds_sheet_close)
        FruxDragHandle(
            modifier =
                Modifier.semantics {
                    role = Role.Button
                    contentDescription = closeLabel
                    onClick {
                        onDismiss()
                        true
                    }
                },
        )
        content()
    }
}
